import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

function current(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(QUERY).matches
}

/**
 * True when the person asked the OS for reduced motion. Live: follows the
 * setting if it changes while the page is open. For JS-driven motion (chart
 * draw-in, scripted transitions) that the global CSS rule cannot reach.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(current)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(QUERY)
    const onChange = () => setReduced(mq.matches)
    onChange()
    mq.addEventListener?.('change', onChange)
    return () => mq.removeEventListener?.('change', onChange)
  }, [])
  return reduced
}
